<template>
  <div id="dataset-followers-list">
    <button
      type="button"
      class="btn btn-primary"
      @click="copyToClipboard"
    >
      <i :class="`bi bi-clipboard${isEmailsCopied ? '-check' : ''}`" />
      {{ $t('datasetDetail.followers.copyFollowerList') }}
    </button>
    <ul class="list-group">
      <li
        v-for="follower of followers.filter(follower => follower.email && follower.email.length > 0)"
        :key="follower.id"
        class="list-group-item"
      >
        <div class="d-flex w-100 justify-content-between">
          <h6 class="mb-1">
            {{ follower.first_name }} {{ follower.last_name }}
          </h6>
          <small>{{ follower.username }}</small>
        </div>
        <small class="fst-italic">
          {{ follower.email }}
        </small>
      </li>
    </ul>
  </div>
</template>

<script>
import datasetAPI from '@/api/modules/dataset.api.js';

export default {
  name: 'DatasetFollowers',

  props: {
    datasetId: {
      type: [Number, String],
      default: null
    }
  },

  data() {
    return {
      followers: [],
      isEmailsCopied: false
    };
  },

  watch: {
    datasetId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.fetchFollowers();
        }
      }
    }
  },

  async created() {
    try {
      if (!this.datasetId) {
        return;
      }
      await this.fetchFollowers();
    } catch (error) {
      console.error(error);
    }
  },

  methods: {
    async fetchFollowers() {
      const followers = await datasetAPI.getDatasetFollowers(this.datasetId);
      this.followers = followers || [];
    },

    copyToClipboard() {
      const emails = this.followers
        .filter(follower => follower.email && follower.email.length > 0)
        .map(follower => follower.email)
        .join(';');
      navigator.clipboard.writeText(emails);
      this.isEmailsCopied = true;
      setTimeout(() => {
        this.isEmailsCopied = false;
      }, 1000);
    },
  }
};
</script>

<style lang="less" scoped>
#dataset-followers-list {
  display: flex;
  flex-direction: column;
  .btn {
    align-self: flex-end;
    i {
      margin-right: 0.5rem;
      font-size: 1.1rem;
    }
  }
  .list-group {
    margin: 0.5rem 0 0 1rem;
    .list-group-item {
      padding: 0.5rem 1rem;
    }
  }
}
</style>
